import { Widget } from "../../utils/helper";
import BotChat from "./BotChat";
import UserChat from "./UserChat";

interface Props {
  message: string;
  type: "bot" | "user";
  buttons?: Widget[];
}

function ChatBox(props: Props) {
  const { message, type, buttons } = props;

  if (type === "user") {
    return <UserChat message={message} />;
  } else if (type === "bot") {
    return <BotChat message={message} buttons={buttons} />;
  }
  return <></>;
}

export default ChatBox;
